// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1CYoc","title":"AfterFrontImage_title__1Azz1"};